<template>
  <!-- 使用 van-popup 替代 el-dialog -->
  <van-popup v-model="open" :close-on-click-overlay="false" round closeable position="bottom" style="max-height: 90%;">
    <div class="dialog-content">
      <!-- 标题栏 -->
      <div class="dialog-header">
        <h3>{{ title }}</h3>
      </div>

      <!-- 表单内容 -->
      <div class="dialog-body">
        <!-- 新增用户表单 (btnShow == 1) -->
        <template v-if="btnShow == 1">
          <van-field
            v-model="form.name"
            label="姓名"
            placeholder="请输入姓名"
            clearable
            :rules="[{ required: true, message: '请输入姓名' }]"
            @blur="$refs.form.validateField('name')"
          />

          <van-field
            v-model="form.userId"
            label="手机号"
            placeholder="请输入手机号"
            type="tel"
            clearable
            :rules="[{ required: true, message: '请输入手机号' }]"
            @blur="$refs.form.validateField('userId')"
          />

          <div class="form-item">
            <div class="form-label">图片</div>
            <image-upload v-model="faceImg" :isShowTip="true" :limit="9" />
          </div>
        </template>

        <!-- 修改用户（仅展示）(btnShow == 2) -->
        <template v-if="btnShow == 2">
          <van-field
            v-model="userInfoName"
            label="用户"
            placeholder="请输入用户"
            disabled
          />
        </template>

        <!-- 添加人脸（追加/替换）(btnShow == 3) -->
        <template v-if="btnShow == 3">
          <div class="formBox">
            <span>操作方式：</span>
            <van-radio-group v-model="actionType" direction="horizontal" class="action-radio-group">
                  <van-radio name="APPEND">追加</van-radio>
                  <van-radio name="REPLACE">替换</van-radio>
          </van-radio-group>
          </div>

          <div class="action-tip">
            <p>追加：新增的人脸照片和历史照片同步保存</p>
            <p>替换：新增的人脸照片会替换历史所有照片</p>
          </div>

          <div class="form-item">
            <div class="form-label">上传图片</div>
            <image-upload v-model="faceImg" :isShowTip="true" :limit="9" />
          </div>
        </template>
      </div>

      <!-- 按钮区域 -->
      <div class="dialog-footer">
        <van-button block type="primary" @click="submitForm">确 定</van-button>
        <van-button block @click="cancel" style="margin-top: 10px;">取 消</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {
  faceLibraryaddUser,
  faceLibraryupd,
  faceLibraryaddFace,
} from "@/api/faceDatabase";

export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {
        platForm: null,
        userId: null,
        userInfo: null,
        createUser: null,
      },
      faceImg: [],
      // 表单校验（保留用于手动触发）
      rules: {},
      btnShow: 1,
      userInfoName: null,
      actionType: "APPEND",
    };
  },
  methods: {
    addCreateForm(oriApi, userName, platForm) {
      this.reset();
      this.open = true;
      this.form.createUser = userName ? userName : 'userName';
      this.form.platForm = platForm;
      this.title = "添加用户";
      this.btnShow = 1;
    },
    showCreateForm(record) {
      this.reset();
      this.open = true;
      this.form = record;
      this.title = "修改用户";
      this.btnShow = 2;
    },
    addFaceForm(record) {
      this.reset();
      this.open = true;
      this.form = record;
      this.title = "添加人脸";
      this.actionType = "APPEND";
      this.btnShow = 3;
    },
    reset() {
      this.form = {
        platForm: null,
        userId: null,
        userInfo: null,
      };
      this.faceImg = [];
    },
    submitForm() {
          if (this.faceImg.length > 0) {
            this.form.urlList = Array.isArray(this.faceImg) ? this.faceImg : this.faceImg.split(",").filter(Boolean);
          }
          const obj = {
            id: this.form.userId,
            name: this.form.name,
          };
          this.form.userInfo = JSON.stringify(obj);

          if (this.form.id != null) {
            if (this.btnShow == 2) {
              // updateOrderDeviceReplace(this.form).then((response) => {
              //   this.$toast.success("修改成功");
              //   this.open = false;
              //   this.$emit("ok");
              // });
            } else if (this.btnShow == 3) {
              const data = {
                id: this.form.id,
                actionType: this.actionType,
                urlList: this.form.urlList,
              };
              faceLibraryaddFace(data).then((response) => {
                this.$toast.success("新增人脸成功");
                this.open = false;
                this.$emit("ok");
              });
            }
          } else {
            faceLibraryaddUser(this.form).then((response) => {
              this.$toast.success("新增成功");
              this.open = false;
              this.$emit("ok");
            });
          }
    },
    cancel() {
      this.open = false;
      this.$emit("ok");
    },
  },
  mounted() {},
};
</script>

<style scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-size: 14px;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
}

.dialog-header {
  padding: 16px 16px 12px;
  text-align: center;
  border-bottom: 1px solid #f2f2f2;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.dialog-body {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
}

/* 表单项通用样式 */
.form-item {
  margin-bottom: 16px;
}

.form-label {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 500;
}

/* 单选按钮组样式 */
.action-radio-group {
  margin-bottom: 16px;
}

.action-tip {
  padding: 12px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #e63946;
  background-color: #f9f9f9;
  border-radius: 8px;
  line-height: 1.5;
}

.action-tip p {
  margin: 4px 0;
}

/* 按钮区域 */
.dialog-footer {
  padding: 12px 16px 20px;
  background-color: #fff;
  border-top: 1px solid #f2f2f2;
}
.formBox{
  display: flex;
}
</style>